//import { SearchBar, DropdownButton } from "@artprov/design-system" TODO: temporal
import { SearchBar } from "@artprov/design-system"
import PropTypes from "prop-types";
import { ExportExcel } from "../../../common/components/button/ExportExcel";
import ModalFilter from "./ModalFilter"
import TagsFilters from "./TagFilters";
import { useComprasAuth } from "../../../common/hooks/useComprasAuth.js";

export default function InvoiceFilters({ onSearch, onFetchExcelData, onFiltersApply, appliedFilters, onRemoveFilter }) {
    const { userDetails } = useComprasAuth();
    const validateUsername = !!userDetails?.userPurchasePermissions;

    // ✅ Función que transforma datos y carga bajo demanda
    const fetchAndTransformExcelData = async () => {
        const invoicesData = await onFetchExcelData();

        if (!invoicesData || invoicesData.length === 0) return [];

        return invoicesData.map(invoice => {
            const base = {};
            base['Razón Social'] = invoice.RAZON_SOCIAL || '';
            base['CUIT'] = invoice.CUIT || '';
            if (validateUsername) {
                base['Sector'] = invoice.FE_SECTORDESTINO || '';
            }
            base['N° Comprobante'] = invoice.NRO_COMPROBANTE || '';
            base['Tipo'] = invoice.TIPO || '';
            base['OC'] = invoice.ORDEN_COMPRA || '';
            base['Fecha Emisión'] = invoice.FECHA_EMISION || '';
            base['Fecha Recepción'] = invoice.FECHA_RECEPCION || '';
            base['Importe'] = invoice.IMPORTE || '';
            base['Número Despacho'] = invoice.NUMERO_DESPACHO || '';
            base['Estado'] = invoice.ESTADOCOMPROBANTE || '';
            return base;
        });
    };
    return (
        <div className="w-full flex items-center justify-between">
            <div className="w-full flex items-center gap-4">
                <SearchBar
                    placeholder="Buscar por razón social, CUIT o factura"
                    setSearchValue={onSearch}
                    opciones={[]}                    
                    classNameContainer="w-[330px]"
                    classNameContainerInput="w-full"
                    className="w-full"
                />
                <ModalFilter onFiltersApply={onFiltersApply} />
                <TagsFilters appliedFilters={appliedFilters} onRemoveFilter={onRemoveFilter} />
            </div>
            <div className="w-full flex items-center justify-end gap-4">
                <ExportExcel
                    textButton="Descargar excel"
                    onFetchData={fetchAndTransformExcelData}
                    excelName="facturas_reporte"
                    sheetName="Facturas"
                />
            </div>
        </div>
    )
}

InvoiceFilters.propTypes = {
    onSearch: PropTypes.func.isRequired,
    onFetchExcelData: PropTypes.func.isRequired,
    onFiltersApply: PropTypes.func.isRequired,
    appliedFilters: PropTypes.object,
    onRemoveFilter: PropTypes.func,
}
